/**
 * Role-based UI permission helpers
 * Backend enforces authorization independently; these only control UI visibility
 */

export const canEdit = (role) => role === 'Owner' || role === 'Admin';
export const canDelete = (role) => role === 'Owner';
export const canManageMembers = (role) => role === 'Owner' || role === 'Admin';
